import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  ButtonDropdown,
  Card,
  CardBody,
  InputGroup,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { localeOptions } from '../../../../../../constants/defaultValues';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import IntlMessages from '../../../../../../helpers/IntlMessages';

export default function Topics({ saveIntegration, integration }) {
  const [topics, setTopics] = useState(
    integration?.phoneSuiteIntegration?.topics || []
  );

  const handleSave = (e) => {
    saveIntegration({ topics: topics });
  };

  const handleAddEmails = () => {
    let lst = [...topics];
    lst.push('');
    setTopics(lst);
  };

  const handlRemove = (e) =>
    setTopics(topics.filter((f, index) => index !== e));

  const handleChange = (e, index) => {
    let lst = [...topics];
    lst[index] = e.target.value;
    setTopics(lst);
  };

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6> Topic Detection</h6>
            <span>
              Detects the main topics in conversations, helping you categorize, view, and analyze conversations by topic.{' '}
            </span>
          </div>
          <Separator className="mb-3" />

          <div className="text-left mb-2">
            <h6>
              {' '}
              <IntlMessages id="content.topics" />{' '}
            </h6>
          </div>

          {topics.map((m, index) => (
            <div className="row mt-1 ml-2 mb-2">
              <div className="col-md-9">
                <InputGroup>
                  <Input
                    value={m}
                    type="text"
                    onChange={(e) => handleChange(e, index)}
                  ></Input>
                </InputGroup>
              </div>
              <div className="col-md-3">
                <Button
                  color="danger"
                  outline
                  size="xs"
                  onClick={() => handlRemove(index)}
                >
                  X
                </Button>
              </div>
            </div>
          ))}
          <div className="row mt-1 ml-2 mb-3">
            <div className="d-flex w-100">
              <Button
                color="primary"
                outline
                size="xs"
                onClick={handleAddEmails}
              >
                + Add Topic
              </Button>
            </div>
          </div>
          <Separator className="mb-2" />
          <Colxx md="12" className="text-center mb-2">
            <Button
              onClick={() => handleSave()}
              color="primary"
              size="xs"

            >
              Save
            </Button>
          </Colxx>
        </CardBody>
      </Card>
    </Fragment>
  );
}
